import React from 'react';
import { ShipmentCostTemplate } from 'themes/modules/shipment-cost/pages';
import { ShipmentCostViewStore } from 'modules/shipment-cost/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ShipmentCostViewStore(rootStore), 'shipmentCostViewStore')
class ShipmentCost extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<ShipmentCostTemplate
				{...this.props}
				change={this.props.shipmentCostViewStore.change}
				actions={this.props.shipmentCostViewStore}
				viewStore={this.props.shipmentCostViewStore}
			/>
		);
	}
}

export default ShipmentCost;
